<template>
  <div
    class="input-label"
    :class="{ 'input-label--unwrap': wrapLabel === false }"
  >
    <BasicText
      v-if="required"
      class="input-label__required"
    >
      <span>*</span>
    </BasicText>
    <BasicText
      size="body-m"
      wrap
      :nbMaxLines
    >
      <slot>{{ label }}</slot>
    </BasicText>
    <BasicTooltip
      v-if="help"
      :label="help"
      position="top"
      :max-width="280"
    >
      <span class="input-label__icon">
        <BasicIcon
          name="help"
          active
        />
      </span>
    </BasicTooltip>
  </div>
</template>

<script setup lang="ts">
  import { type InputLabelProps } from '@designSystem/components'

  withDefaults(defineProps<InputLabelProps>(), {
    wrapLabel: true,
  })
</script>

<style lang="less">
  @import './BasicInputLabel.less';
</style>
